import React, { useState } from 'react'
import { Tab, Tabs } from '@mui/material'
import StackedBar from './StackedBar'
import HorizBar from './HorizBar'
import BarChart from './BarChart'
import styles from './styles.module.css'

const BAR_CHART = 'Bar Chart'
const HORIZ_BAR = 'Horizontal'
const STACKED_BAR = 'Stacked'

const BarCharts = (props) => {
  const { tab, isFullScreen } = props
  const [index, setIndex] = useState(tab ?? 0)
  const width = window.innerWidth / 3

  const handleChange = (event) => {
    const labelElement = event.target.innerHTML
    if (labelElement.includes(BAR_CHART)) {
      setIndex(0)
    } else if (labelElement.includes(HORIZ_BAR)) {
      setIndex(1)
    } else {
      setIndex(2)
    }
  }
  return (
    <div style={{ overflow: 'scroll' }}>
      {isFullScreen ? null : (
        <Tabs
          value={index}
          fullWidth
          onChange={handleChange}
          className={styles.tabContainer}
        >
          <Tab label={BAR_CHART} style={{ width, color: index==0 ? 'skyblue' : 'lightgray' }} />
          <Tab label={HORIZ_BAR} style={{ width, color: index==1 ? 'skyblue' : 'lightgray' }} />
          <Tab label={STACKED_BAR} style={{ width, color: index==2 ? 'skyblue' : 'lightgray' }} />
        </Tabs>
      )}

      {index === 2 ? (
        <StackedBar isMobile />
      ) : index === 1 ? (
        <HorizBar isMobile />
      ) : (
        <BarChart isMobile />
      )}
    </div>
  )
}

export default BarCharts
